var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Autorizador'),_c('AvisoPagamento'),_c('Menu'),_c('div',{ref:"conteudo",staticClass:"conteudo"},[_c('Topo'),_c('transition',{attrs:{"name":"fadeTransition"}},[_c('router-view')],1),_c('chat-widget')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }